import { createFileRoute } from '@tanstack/react-router'
import { HireApplicantDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import HireApplicantDialog from '@/routes/_app/-dialogs/hire-applicant'

export const Route = createFileRoute('/@modal/applicants/$applicantId_/hire')({
  params: idParams('applicantId'),
  staticData: { slotScope: '/_app/offers/_list/$offerId' },
  pendingComponent: HireApplicantDialogPending,
  component: HireApplicantSlot,
})

function HireApplicantSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <HireApplicantDialog applicantId={Number(params.applicantId)} {...slot} />
}
